import React from "react";
import { DesktopMainMenu,  MenuLink } from "../styles";
import CustomButton from "../../CustomBtn";

const DesktopMenu = (props) => {
 
  return (
    <DesktopMainMenu maxWidth="xl">
      <MenuLink href="/" p="0px">
        <div style={{display:"flex",alignItems:"center"}}>
        <img src="./Images/logo.png" width="230px" alt="Logo" />
        </div></MenuLink>
      <div>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
        <MenuLink href="https://t.me/moonracerfinance" target="blank"><CustomButton>Join Community</CustomButton></MenuLink>
        {/* <FormControlLabel
          control={
            <MaterialUISwitch 
              sx={{ m: 1 }} 
              checked={currentTheme}
            />
          }
          onClick={() => dispatch(toggleTheme())}
        /> */}
      </div>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
